import { ModuleFE_ContextRule } from '@app/hcs-frontend';
export const getSelectedContextRulesIds = (ehrContextRulesIds) => ModuleFE_ContextRule.cache.filter(({ _id }) => !!ehrContextRulesIds?.includes(_id));
//# sourceMappingURL=utils.js.map